module.exports = __webpack_public_path__ + "0b97df6b65c7f82747b248e305277816.gif";